module.exports = __webpack_public_path__ + "img/1_2-macerie-0.37fb7a7d.png";